import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterBooleanSearchValueObject} from './FilterBooleanSearchValueObject.js'

export class FilterOnlyPeninsulaSearchValueObject extends ValueObject {
  #onlyPeninsula

  constructor({onlyPeninsula}) {
    super()
    this.#onlyPeninsula = onlyPeninsula
  }

  static create({onlyPeninsula}) {
    return new FilterOnlyPeninsulaSearchValueObject({
      onlyPeninsula: FilterBooleanSearchValueObject.create(onlyPeninsula)
    })
  }

  static createWithDefaultValue({config, onlyPeninsula}) {
    const {DEFAULT_ONLY_PENINSULA_SEARCH} = config.get('searchFilters')

    return new FilterOnlyPeninsulaSearchValueObject({
      onlyPeninsula: FilterBooleanSearchValueObject.create({boolean: onlyPeninsula ?? DEFAULT_ONLY_PENINSULA_SEARCH})
    })
  }

  static createQueryParams({config, onlyPeninsula}) {
    const {DEFAULT_ONLY_PENINSULA_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterOnlyPeninsulaSearchValueObject({
      onlyPeninsula: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.ONLY_PENINSULA],
        value: onlyPeninsula === DEFAULT_ONLY_PENINSULA_SEARCH ? null : onlyPeninsula
      })
    })
  }

  get isEmpty() {
    return this.#onlyPeninsula.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#onlyPeninsula.queryParam})
    }
  }

  get value() {
    return this.#onlyPeninsula.value
  }

  toJSON() {
    return {
      onlyPeninsula: this.#onlyPeninsula.toJSON()
    }
  }
}
